module.exports = __webpack_public_path__ + "img/news3.de9049f0.png";